import React from 'react'

import HintPopover from '../../../gd-ui/hint-popover/hint-popover'
import TaskType from "../../../model2/task-type/task-type"
import {ItemIconClass} from "../../../gd/const/item-icon/icon/item-icon-class";

type Props = {
    className?      : string

    size            : string | number                //allowed values: 14

    taskType?       : TaskType
    systemStatus?   : number
    priority?       : number
    icon?           : string

    taskTypeId?     : ID

    hint            : boolean

    onClick?        : func
}

export default class TaskIcon extends React.Component<Props> {

    static defaultProps = {
        size: 'normal',
        hint: false
    }

    render() {
        let iconName, specialIcon, typeName

        if (this.props.taskType) {
            iconName = this.props.taskType.icon
            typeName = this.props.taskType.name
        } else if (this.props.icon) {
            iconName = this.props.icon
        } else if (this.props.taskTypeId) {
            const sessionTaskType = gd.session.taskTypes.get(this.props.taskTypeId)
            if (sessionTaskType) {
                iconName = sessionTaskType.icon
                typeName = sessionTaskType.name
            }
            else console.log("WARNING #98ed76 - TaskIcon: task type not found in session")
        }

        let taskIcon = iconName ? ItemIconClass[iconName] : null

        if (this.props.systemStatus && gd.const.systemStatus.isClosed(this.props.systemStatus)) {
            specialIcon = <div className="status-icon i5-checkbox-ok"> </div>;
        } else if (this.props.priority) {
            switch(this.props.priority) {
                case gd.const.priority.levels.emergency:
                    taskIcon = "i5-emergency"
                    break

                case gd.const.priority.levels.blocker:
                    taskIcon = "i5-flag"
                    break

                default:
                    if (this.props.priority > 5) {
                        const priorityStyle = {
                            backgroundColor: '#' + gd.const.priority.colors[this.props.priority]
                        }

                        specialIcon = <div className="priority-icon" style={priorityStyle}/>
                    }
                    break;
            }
        }

        const classes = Classes("gd-task-icon", taskIcon, "size-"+this.props.size, this.props.className, {
            'completed': gd.const.systemStatus.isClosed(this.props.systemStatus)
        })

        if (this.props.hint && typeName) {
            return (
                <div className={classes} onClick={this.props.onClick}>
                    {specialIcon}
                    <HintPopover parent={this} hint={typeName}/>
                </div>
            )
        } else {
            return <div className={classes} onClick={this.props.onClick}>{specialIcon}</div>
        }
    }
}